import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal, Button, Form } from 'semantic-ui-react';
import { Formik, Field } from 'formik';
import { shape, func } from 'prop-types';
import { TextAreaField, CurrencyField } from 'Modules/Formik';
import { createPOS } from 'Redux/modules/webChat/pos/actions';
import * as Yup from 'yup';
import { round } from 'Helpers/utils';
import useProfile from 'Hooks/doctor/useDoctorProfile';
import { removeModal } from 'Redux/modules/modal/actions';
import { CURRENCY_SYMBOLS } from 'Constants/commons';
import { CurrencyLabel } from 'Modules/Currency';

import styles from './POS.less';

const POSSchema = Yup.object().shape({
  description: Yup.string().required('This field is required').max(150, 'The max length is 150'),
  amount: Yup.string().required('This field is required'),
});

const POS = props => {
  const {
    id,
    data: { conversation },
  } = props;
  const dispatch = useDispatch();
  const doctor = useSelector(state => state.webChat.doctor.data);
  const statusPos = useSelector(state => state.webChat.pos.status);
  const {
    profile: { currency },
  } = useProfile();

  const { id: doctorId, taxProfile } = doctor;
  const taxPercent = taxProfile?.taxPercent || 0;

  const {
    latestConsult: { id: consultId },
  } = conversation;

  const close = () => {
    dispatch(removeModal(id));
  };

  const onSubmit = async values => {
    const body = { ...values, doctorId };
    await dispatch(createPOS(consultId, body));
    close();
  };

  let mHandleSubmit = null;
  const hanldeSubmit = () => {
    mHandleSubmit();
  };

  const loading = statusPos.create === 0;
  const currencySymbol = CURRENCY_SYMBOLS[currency] || '';

  let taxTotal = `Total (tax ${taxPercent} % included):`;
  if (taxPercent === 0) taxTotal = 'Total:';

  return (
    <Formik
      initialValues={{ amount: '', description: '' }}
      onSubmit={onSubmit}
      validationSchema={POSSchema}>
      {({ handleSubmit, values }) => {
        mHandleSubmit = handleSubmit;
        const total = round((taxPercent / 100 + 1) * values.amount, 2);
        return (
          <Modal open onClose={close} closeOnDimmerClick={false} closeIcon size="small">
            <Modal.Header>Point of Sale</Modal.Header>
            <Modal.Content>
              <Form>
                <Field
                  label="Transaction for (*)"
                  name="description"
                  component={TextAreaField}
                  maxlengthchar={150}
                />
                <Field
                  label="Total amount of money (*)"
                  name="amount"
                  component={CurrencyField}
                  excludeSeparator
                  currencyCode={currencySymbol}
                />
              </Form>
            </Modal.Content>
            <Modal.Actions>
              <div className={styles.left}>
                <span className={styles.labelTotal}>{taxTotal}</span>
                <span>
                  {currencySymbol} <CurrencyLabel value={total} />
                </span>
              </div>
              <div>
                <Button content="Cancel" onClick={close} style={{ marginRight: 8 }} />
                <Button
                  content="Apply"
                  type="button"
                  primary
                  onClick={hanldeSubmit}
                  loading={loading}
                  disabled={loading}
                />
              </div>
            </Modal.Actions>
          </Modal>
        );
      }}
    </Formik>
  );
};

POS.propTypes = {
  conversation: shape({}).isRequired,
};

export default POS;
